const NAV_DEFS: Array<{ label: string; icon: string; to: string }> = [
  { label: 'نمای کلی', icon: 'i-lucide-layout-dashboard', to: '/support' },
  { label: 'تیکت‌ها', icon: 'i-lucide-life-buoy', to: '/support/tickets' },
  { label: 'خطاها و باگ‌ها', icon: 'i-lucide-bug', to: '/support/error-logs' },
  { label: 'مشتریان', icon: 'i-lucide-users', to: '/support/customers' },
  { label: 'تنظیمات', icon: 'i-lucide-settings', to: '/support/settings' },
]

const BREADCRUMB_LABELS: Record<string, string> = {
  '/support': 'نمای کلی',
  '/support/tickets': 'تیکت‌ها',
  '/support/error-logs': 'خطاها و باگ‌ها',
  '/support/customers': 'مشتریان',
  '/support/settings': 'تنظیمات',
}

export function useSupportNav() {
  const route = useRoute()

  const navItems = computed(() => [NAV_DEFS.map((item) => ({ ...item }))])

  const searchGroups = computed(() => [
    {
      id: 'pages',
      label: 'صفحات',
      items: NAV_DEFS.map((d) => ({
        id: d.to,
        label: d.label,
        icon: d.icon,
        to: d.to,
      })),
    },
  ])

  const breadcrumbs = computed(() => {
    const path = route.path.replace(/\/$/, '') || '/support'
    if (path.startsWith('/support/tickets/') && path !== '/support/tickets') {
      return [
        { label: 'پنل پشتیبانی', to: '/support' },
        { label: 'تیکت‌ها', to: '/support/tickets' },
        { label: 'جزئیات تیکت' },
      ]
    }
    if (path.startsWith('/support/error-logs/') && path !== '/support/error-logs') {
      const isAnalytics = path.endsWith('/analytics')
      return [
        { label: 'پنل پشتیبانی', to: '/support' },
        { label: 'خطاها و باگ‌ها', to: '/support/error-logs' },
        { label: isAnalytics ? 'تحلیل' : 'جزئیات باگ' },
      ]
    }
    if (path.startsWith('/support/customers/') && path !== '/support/customers') {
      return [
        { label: 'پنل پشتیبانی', to: '/support' },
        { label: 'مشتریان', to: '/support/customers' },
        { label: 'سایت مشتری' },
      ]
    }
    const label = BREADCRUMB_LABELS[path] ?? 'پنل پشتیبانی'
    return [
      { label: 'پنل پشتیبانی', to: '/support' },
      { label },
    ]
  })

  return { navItems, searchGroups, breadcrumbs }
}
